import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from '../hooks/useTranslation';
import '../styles/AppointmentForm.css';

const AppointmentForm = () => {
  const { t } = useTranslation();
  return (
    <section id="appointment" className="appointment-section">
      <motion.div 
        className="appointment-container"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <h2>{t('appointment.title')}</h2>
        <p className="appointment-intro">
          {t('appointment.intro')}
        </p>
        
        <div className="appointment-options">
          <motion.a 
            href="https://cal.com/llamas-jonathan/30min" 
            target="_blank" 
            rel="noopener noreferrer"
            className="appointment-option cal-option"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <div className="option-icon">
              <FontAwesomeIcon icon={faCalendarAlt} />
            </div>
            <div className="option-content">
              <h3>{t('appointment.scheduleInterview')}</h3>
              <p>{t('appointment.scheduleDesc')}</p>
            </div>
          </motion.a>
          
          <motion.a 
            href="https://linkedin.com/in/jonathanllamas" 
            target="_blank" 
            rel="noopener noreferrer"
            className="appointment-option linkedin-option"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <div className="option-icon">
              <FontAwesomeIcon icon={faLinkedin} />
            </div>
            <div className="option-content">
              <h3>{t('appointment.contactLinkedIn')}</h3>
              <p>{t('appointment.linkedInDesc')}</p>
            </div>
          </motion.a>
          
          <motion.a 
            href="mailto:jonathan@llamas.ovh" 
            className="appointment-option email-option"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <div className="option-icon">
              <FontAwesomeIcon icon={faEnvelope} />
            </div>
            <div className="option-content">
              <h3>{t('appointment.sendEmail')}</h3>
              <p>{t('appointment.emailDesc')}</p>
            </div>
          </motion.a>

          <motion.a 
            href={`/CV_LLAMAS_JONATHAN.pdf?v=${process.env.REACT_APP_BUILD_ID}`} 
            download="CV_LLAMAS_JONATHAN.pdf"
            className="appointment-option download-option"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <div className="option-icon">
              <FontAwesomeIcon icon={faFilePdf} />
            </div>
            <div className="option-content">
              <h3>{t('appointment.downloadCV')}</h3>
              <p>{t('appointment.cvDesc')}</p>
            </div>
          </motion.a>
        </div>
        
        <div className="availability-note">
          <div className="gear-decoration"></div>
          <p>
            <strong>{t('appointment.availability')}</strong> {t('appointment.availabilityStatus')}
          </p>
          <div className="gear-decoration"></div>
        </div>
      </motion.div>
    </section>
  );
};

export default AppointmentForm;
